module.exports = __webpack_public_path__ + "img/sec3_4.5630709b.png";